import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ReservationList } from '../../../_models/reservation.model';
import { Router } from '@angular/router';
import { OfferUtilsService } from '../../../_utils/offer-utils.service';

@Component({
  selector: 'app-admin-member-reservations-card',
  imports: [CommonModule],
  templateUrl: './admin-member-reservations-card.html',
  styleUrl: './admin-member-reservations-card.scss',
})
export class AdminMemberReservationsCard {
  @Input() reservations!: ReservationList[];

   constructor(
    private router: Router,
    private offerUtils: OfferUtilsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  details(reservationId: number){
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/admin/reservations/details',
        reservationId
      ])
    );
    if (isPlatformBrowser(this.platformId)) {
        window.open(url, '_blank');
    }
  }

  getReservationAdminStatusClass(reservation: any): string {
    return this.offerUtils.getReservationOverallStatusClass(reservation.reservationClientStatus, reservation.reservationAdminStatus);
  }

  getReservationAdminStatusText(reservation: any): string {
    return this.offerUtils.getReservationOverallStatusText(reservation.reservationClientStatus, reservation.reservationAdminStatus);
  }

  formatAddress(address: any): string {
    if (!address) return 'Non spécifiée';
    
    const parts: string[] = [];
    
    if (address.streetNumber && address.street) {
      parts.push(`${address.street} ${address.streetNumber}`);
    } else if (address.street) {
      parts.push(address.street);
    }
    
    if (address.postalCode && address.city) {
      parts.push(`${address.postalCode} ${address.city}`);
    } else if (address.postalCode) {
      parts.push(address.postalCode);
    } else if (address.city) {
      parts.push(address.city);
    }
    
    if (parts.length === 0) {
      return 'Non spécifiée';
    }
    
    return parts.join(', ') + ".";
  }
}
